/**
 * @generated SignedSource<<5432b30245a6345c5d41d0875b65f74d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type CategoryGroupHeader$data = {
  readonly displayName: string;
  readonly option: {
    readonly color: {
      readonly colorKey: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "CategoryGroupHeader";
};
export type CategoryGroupHeader$key = {
  readonly " $data"?: CategoryGroupHeader$data;
  readonly " $fragmentSpreads": FragmentRefs<"CategoryGroupHeader">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "CategoryGroupHeader",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "displayName"
    },
    {
      "concreteType": "JiraOption",
      "kind": "LinkedField",
      "name": "option",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraColor",
          "kind": "LinkedField",
          "name": "color",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "colorKey"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraJqlOptionFieldValue"
};

(node as any).hash = "adc155d7b590635f8d7c06317caf565c";

export default node;
